import { FunctionComponent } from "react";
import { PageRouting } from "./modules/router/components/page-routing";
import { IonApp } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { AnnotationIdProvider } from "./modules/plan/contexts/annotation-id.context";
import { AnnotationLibraryProvider } from "./modules/annotation/contexts/annotation-library.context";
import { MetaLibraryProvider } from "./modules/plan/contexts/meta-library.context";
import { useCacheBuster } from "./hooks/useCacheBuster";

export const App: FunctionComponent = () => {
  useCacheBuster();
  
  return (
    <IonApp>
      <IonReactRouter>
        <AnnotationLibraryProvider>
          <MetaLibraryProvider>
            <AnnotationIdProvider>
              <PageRouting />
            </AnnotationIdProvider>
          </MetaLibraryProvider>
        </AnnotationLibraryProvider>
      </IonReactRouter>
    </IonApp>
  );
};
